export const BUTTON_VARIANTS = [
  { value: 'primary', label: 'Primary (purple)' },
  { value: 'secondary', label: 'Secondary (outline)' },
  { value: 'beta', label: 'Beta (gold)' },
  { value: 'custom', label: 'Custom colours' },
];

export const ICON_OPTIONS = [
  { value: '', label: 'No icon' },
  { value: 'fas fa-download', label: 'Download' },
  { value: 'fas fa-flask', label: 'Flask (beta)' },
  { value: 'fas fa-paint-brush', label: 'Paint brush' },
  { value: 'fas fa-external-link-alt', label: 'External link' },
  { value: 'fas fa-play', label: 'Play' },
  { value: 'fas fa-cog', label: 'Settings' },
  { value: 'fas fa-link', label: 'Link' },
  { value: 'fas fa-info-circle', label: 'Info' },
];

export function defaultButton(overrides = {}) {
  return {
    href: '',
    text: '',
    icon: 'fas fa-download',
    variant: 'primary',
    primary: true,
    download: false,
    external: false,
    style: {
      background: '',
      color: '',
      borderColor: '',
      hoverBackground: '',
    },
    ...overrides,
  };
}

export function defaultBetaBlock() {
  return {
    href: '',
    text: '',
    description: '',
    icon: 'fas fa-flask',
    variant: 'beta',
    style: {
      background: '',
      color: '',
      borderColor: '',
      hoverBackground: '',
    },
  };
}

export function normalizeIcon(icon) {
  if (!icon) return null;
  const trimmed = icon.trim();
  if (!trimmed) return null;
  if (trimmed.includes(' ')) return trimmed;
  return `fas ${trimmed.startsWith('fa-') ? trimmed : `fa-${trimmed}`}`;
}

export function resolveButtonVariant(btn) {
  if (btn.variant) return btn.variant;
  return btn.primary ? 'primary' : 'secondary';
}
